import { render, staticRenderFns } from "./chose_pay.vue?vue&type=template&id=7be6fb67&scoped=true&"
import script from "./chose_pay.vue?vue&type=script&lang=js&"
export * from "./chose_pay.vue?vue&type=script&lang=js&"
import style0 from "./chose_pay.vue?vue&type=style&index=0&id=7be6fb67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be6fb67",
  null
  
)

export default component.exports